module.exports = __webpack_public_path__ + "static/media/19ESCAP20.510d4a82.jpg";